import React, { useEffect, useState } from 'react';
import Main from '../Main';
import { Col, Row, Tab, Nav } from 'react-bootstrap';
import '../../assets/css/dashboard.scss';
import '../../assets/css/customermanagement.scss';
import 'react-datepicker/dist/react-datepicker.css';
import AssignToTable from './AssignToTable';
import UpdatedValueTable from './UpdatedValueTable';
import Download from '../MainSection/Download/Download';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadAssignedToSlaData, loadCustomviews, loadUpdateSlaData } from '../../redux/action';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { Document, Packer, Table, TableRow, TableCell, Paragraph } from "docx";
import { saveAs } from "file-saver";
import html2canvas from 'html2canvas';
import moment from 'moment';
import { baseURL } from '../BaseUrl';
import * as HeaderAuthentication from '../HeaderAuthentication'

const SLA = () => {

    let dispatch = useDispatch();
    let location = useLocation();

    const { selectedDashboardID } = location.state || {};

    const { assignedToSlaData = [] } = useSelector((state) => state.data);
    const { updateSlaData = [] } = useSelector((state) => state.data);
    const { customViews = [] } = useSelector((state) => state.data);
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

    const [activeKey, setActiveKey] = useState('assignTo'); // Default active tab
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [updtedSearchText, setUpdatedSearchText] = useState("");
    const [searchParams, setSearchParams] = useState('');
    const [updatedSearchParams, setUpdatedSearchParams] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [updatedSearchQuery, setUpdatedSearchQuery] = useState('');
    const [updateSlaLoading, setUpdateSlaLoading] = useState(false);

    const assignedToSlaDatas = () => {
        dispatch(loadAssignedToSlaData(setLoading, searchQuery, searchParams, null, 'SLA'));
    }
    useEffect(() => {
        if (activeKey === "assignTo") {
            assignedToSlaDatas();
        }
    }, [searchQuery, searchParams, activeKey]); // Add activeKey

    const updatedSlaDatas = () => {
        // dispatch(loadUpdateSlaData(setLoading, updatedSearchQuery, updatedSearchParams));
        dispatch(loadAssignedToSlaData(setUpdateSlaLoading, updatedSearchQuery, updatedSearchParams, null, 'ASLA'));
    }

    useEffect(() => {
        if (activeKey === "updateValue") {
            updatedSlaDatas();
        }
    }, [updatedSearchQuery, updatedSearchParams, activeKey]); // Add activeKey

    const navigate = useNavigate();
    const signInType = signInDetails?.[0]?.SignInType;
    const signInId =
        signInType === "SuperAdmin"
            ? signInDetails?.[0]?.SuperAdminID
            : signInType === "ClientAdmin"
                ? signInDetails?.[0]?.CompanyID
                : signInType === "User"
                    ? signInDetails?.[0]?.UserID
                    : null;
    const handleAnalyticsClick = () => {
        // if (customViews[0]?.IsDefault === true) {
        //     dispatch(loadCustomviews(null, signInType, signInId, 6));
        // }
        dispatch(loadCustomviews(null, signInType, signInId, 6));
        navigate('/slaDashboard', { state: { selectedDashboardID } })
    }

    const handleDashboardLibraryClick = () => {
        navigate('/dashboard-library')
    }

    // Function to handle Excel download
    const handleDownloadExcel = () => {
        // Prepare data to be written to Excel (complainEscalationData)
        const dataToExport = assignedToSlaData?.map(item => ({
            "SLA NO": item.SLAID || "NA",
            "TYPE": item.SLAType || "NA",
            "COMPANY NAME": item.CustomerName || "NA",
            "SLA CATEGORIES": item.SLACategoryName || "NA",
            "DESCRIPTION": item.Remarks || "NA",
            "VALUE TYPE": item.ValueType || "NA",
            "BASELINE": item.BaseLine || "NA",
            "TARGET": item.TargetPercentage || "NA",
            "TARGET VALUE": item.TargetValue || "NA",
            "START DATE": item.StartDate ? moment(item.StartDate).format('DD/MM/YYYY') : "NA",
            "END DATE": item.EndDate ? moment(item.EndDate).format('DD/MM/YYYY') : "NA",
            "ASSIGNED TO": item.AssignedTo || "NA",
        })) || [];

        // Create a new workbook
        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "AssignToSla");

        // Generate Excel file and trigger the download
        XLSX.writeFile(wb, 'assign_to_sla.xlsx');
    };

    // Function to handle PDF download
    const handleDownloadPDF = () => {
        const doc = new jsPDF({ orientation: 'landscape' }); // Landscape for more width

        // Title
        doc.setFontSize(18);
        doc.text("Assign To Sla Data", 14, 20);

        const dataToExport = assignedToSlaData?.map(item => ([
            item.SLAID || "NA",
            item.SLAType || "NA",
            item.CustomerName || "NA",
            item.SLACategoryName || "NA",
            item.Remarks || "NA",
            item.ValueType || "NA",
            item.BaseLine || "NA",
            item.TargetPercentage || "NA",
            item.TargetValue || "NA",
            item.StartDate ? moment(item.StartDate).format('DD/MM/YYYY') : "NA",
            item.EndDate ? moment(item.EndDate).format('DD/MM/YYYY') : "NA",
            item.AssignedTo || "NA",
        ])) || [];

        const columns = [
            { title: "SLA NO", dataKey: "slaNo" },
            { title: "TYPE", dataKey: "type" },
            { title: "COMPANY NAME", dataKey: "companyName" },
            { title: "SLA CATEGORIES", dataKey: "slaCategories" },
            { title: "DESCRIPTION", dataKey: "description" },
            { title: "VALUE TYPE", dataKey: "valueType" },
            { title: "BASELINE", dataKey: "baseline" },
            { title: "TARGET", dataKey: "target" },
            { title: "TARGET VALUE", dataKey: "targetValue" },
            { title: "START DATE", dataKey: "startDate" },
            { title: "END DATE", dataKey: "endDate" },
            { title: "AssignedTo", dataKey: "assignedTo" },
        ];

        // Generate table
        doc.autoTable({
            head: [columns],
            body: dataToExport,
            startY: 30,
            tableWidth: 'auto', // Auto-adjust table to fit page
            styles: {
                fontSize: 8,
                cellPadding: 2,
                overflow: 'linebreak',
            },
            headStyles: {
                fillColor: [22, 160, 133],
                textColor: [255, 255, 255],
                halign: 'center',
            },
        });

        // Save PDF
        doc.save('assign_to_sla.pdf');
    };

    const handleDownloadWord = () => {
        if (!assignedToSlaData || assignedToSlaData.length === 0) {
            console.error("No data available for export.");
            alert("No data to export!");
            return;
        }

        // Prepare data to be added to the Word document
        const dataToExport = assignedToSlaData.map(item => [
            String(item?.SLAID || "NA"),  // Explicitly convert to string
            String(item?.SLAType || "NA"),  // Explicitly convert to string
            String(item?.CustomerName || "NA"),  // Explicitly convert to string
            String(item?.SLACategoryName || "NA"),  // Explicitly convert to string
            String(item?.Remarks || "NA"),  // Explicitly convert to string
            String(item?.ValueType || "NA"),  // Explicitly convert to string
            String(item?.BaseLine || "NA"),  // Explicitly convert to string
            String(item?.TargetPercentage || "NA"),  // Explicitly convert to string
            String(item?.TargetValue || "NA"),  // Explicitly convert to string
            String(item.StartDate ? moment(item.StartDate).format('DD/MM/YYYY') : "NA"),  // Explicitly convert to string
            String(item.EndDate ? moment(item.EndDate).format('DD/MM/YYYY') : "NA"),  // Explicitly convert to string
            String(item?.AssignedTo || "NA"),  // Explicitly convert to string
        ]);

        // Define the headers for the table in the Word document
        const headers = [
            "SLA NO", "TYPE", "COMPANY NAME", "SLA CATEGORIES", "DESCRIPTION", "VALUE TYPE",
            "BASELINE", "TARGET", "TARGET VALUE", "START DATE", "END DATE", "ASSIGNED TO"
        ];

        // Create table rows for the document
        const tableRows = [
            // Header Row
            new TableRow({
                children: headers.map(header => new TableCell({ children: [new Paragraph(header)] }))
            }),
            // Data Rows
            ...dataToExport.map(row =>
                new TableRow({
                    children: row.map(cell => new TableCell({ children: [new Paragraph(cell)] }))
                })
            ),
        ];

        // Create the table
        const table = new Table({
            rows: tableRows
        });

        // Create the document with metadata
        const doc = new Document({
            creator: "Assigned To Sla",
            title: "Assigned To Sla Report",
            description: "A detailed report of Assigned To Sla.",
            sections: [  // Ensure that sections are properly passed as an array
                {
                    children: [table]
                }
            ]
        });

        // Generate and download the Word document
        Packer.toBlob(doc)
            .then(blob => saveAs(blob, "assign_to_sla.docx"))
            .catch(error => {
                console.error("Error generating Word document:", error);
                alert("An error occurred while generating the Word document. Check the console for details.");
            });
    };

    const handlePrint = () => {
        if (!assignedToSlaData || assignedToSlaData.length === 0) {
            console.error("No data available for printing.");
            alert("No data to print!");
            return;
        }

        // Prepare data to be added to the table
        const dataToExport = assignedToSlaData.map(item => [
            item.SLAID || "NA",
            item.SLAType || "NA",
            item.CustomerName || "NA",
            item.SLACategoryName || "NA",
            item.Remarks || "NA",
            item.ValueType || "NA",
            item.BaseLine || "NA",
            item.TargetPercentage || "NA",
            item.TargetValue || "NA",
            item.StartDate ? moment(item.StartDate).format('DD/MM/YYYY') : "NA",
            item.EndDate ? moment(item.EndDate).format('DD/MM/YYYY') : "NA",
            item.AssignedTo || "NA",
        ]);

        // Define the headers for the table in the printable version
        const headers = [
            "SLA NO", "TYPE", "COMPANY NAME", "SLA CATEGORIES", "DESCRIPTION", "VALUE TYPE",
            "BASELINE", "TARGET", "TARGET VALUE", "START DATE", "END DATE", "ASSIGNED TO"
        ];

        // Create HTML table for printing
        let tableHtml = `
            <table border="1" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
                <thead>
                    <tr>
                        ${headers.map(header => `<th style="padding: 8px; background-color: #f2f2f2; text-align: left;">${header}</th>`).join('')}
                    </tr>
                </thead>
                <tbody>
                    ${dataToExport.map(row => `
                        <tr>
                            ${row.map(cell => `<td style="padding: 8px; text-align: left;">${cell}</td>`).join('')}
                        </tr>
                    `).join('')}
                </tbody>
            </table>
        `;

        // Create a print window
        const printWindow = window.open('', '', 'width=800,height=600');
        printWindow.document.write('<html><head><title>Assign To Sla Report</title>');
        printWindow.document.write('<style>body { font-family: Arial, sans-serif; }</style>');
        printWindow.document.write('</head><body>');
        printWindow.document.write('<h1>Assign To Sla Report</h1>');
        printWindow.document.write(tableHtml); // Insert the table
        printWindow.document.write('</body></html>');
        printWindow.document.close(); // Necessary for the document to load

        // Trigger the print dialog after content is loaded
        printWindow.print();
    };

    const handleDownloadImage = () => {
        if (!assignedToSlaData || assignedToSlaData.length === 0) {
            console.error("No data available for exporting.");
            alert("No data to export!");
            return;
        }

        // Prepare data to be added to the table
        const dataToExport = assignedToSlaData.map(item => [
            item.SLAID || "NA",
            item.SLAType || "NA",
            item.CustomerName || "NA",
            item.SLACategoryName || "NA",
            item.Remarks || "NA",
            item.ValueType || "NA",
            item.BaseLine || "NA",
            item.TargetPercentage || "NA",
            item.TargetValue || "NA",
            item.StartDate ? moment(item.StartDate).format('DD/MM/YYYY') : "NA",
            item.EndDate ? moment(item.EndDate).format('DD/MM/YYYY') : "NA",
            item.AssignedTo || "NA",
        ]);

        // Define the headers for the table in the printable version
        const headers = [
            "SLA NO", "TYPE", "COMPANY NAME", "SLA CATEGORIES", "DESCRIPTION", "VALUE TYPE",
            "BASELINE", "TARGET", "TARGET VALUE", "START DATE", "END DATE", "ASSIGNED TO"
        ];

        // Create the table HTML to be rendered
        let tableHtml = `
            <table border="1" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
                <thead>
                    <tr>
                        ${headers.map(header => `<th style="padding: 8px; background-color: #f2f2f2; text-align: left;">${header}</th>`).join('')}
                    </tr>
                </thead>
                <tbody>
                    ${dataToExport.map(row => `
                        <tr>
                            ${row.map(cell => `<td style="padding: 8px; text-align: left;">${cell}</td>`).join('')}
                        </tr>
                    `).join('')}
                </tbody>
            </table>
        `;

        // Create a container div for the table to be captured
        const printContainer = document.createElement('div');
        printContainer.innerHTML = tableHtml;

        // Append the print container to the body (for rendering purposes)
        document.body.appendChild(printContainer);

        // Use html2canvas to convert the table HTML into an image
        html2canvas(printContainer, {
            scale: 2, // Increase the scale to get better image quality (default is 1)
            useCORS: true, // Enable Cross-Origin Resource Sharing (useful if the table includes external images)
            width: printContainer.scrollWidth, // Dynamically set the width of the canvas to fit the content
            height: printContainer.scrollHeight, // Dynamically set the height of the canvas to fit the content
            scrollX: 0, // Ensure that it doesn't pick up the page's scroll position
            scrollY: -window.scrollY // Adjust the scroll position if necessary
        }).then(canvas => {
            // Remove the print container after rendering
            document.body.removeChild(printContainer);

            // Convert canvas to image data URL
            const imgData = canvas.toDataURL('image/png');

            // Create a temporary link to trigger download
            const link = document.createElement('a');
            link.href = imgData;
            link.download = 'assign_to_sla.png'; // Specify the image file name
            link.click(); // Simulate a click event to trigger the download
        });
    };

    const handleEmailWithCsvDownload = async () => {
        const dataToExport = activeKey === 'assignTo'
            ? (Array.isArray(assignedToSlaData) ? assignedToSlaData : []).map(item => ({
                "SLA NO": item.SLAID || "NA",
                "TYPE": item.SLAType || "NA",
                "COMPANY NAME": item.CustomerName || "NA",
                "SLA CATEGORIES": item.SLACategoryName || "NA",
                "DESCRIPTION": item.Remarks || "NA",
                "VALUE TYPE": item.ValueType || "NA",
                "BASELINE": item.BaseLine || "NA",
                "TARGET": item.TargetPercentage || "NA",
                "TARGET VALUE": item.TargetValue || "NA",
                "START DATE": item.StartDate ? moment(item.StartDate).format('DD/MM/YYYY') : "NA",
                "END DATE": item.EndDate ? moment(item.EndDate).format('DD/MM/YYYY') : "NA",
                "ASSIGNED TO": item.AssignedTo || "NA",
            }))
            : (Array.isArray(assignedToSlaData) ? assignedToSlaData : []).map(item => ({
                "SLA NO": item.SLAID || "NA",
                "TYPE": item.SLAType || "NA",
                "COMPANY NAME": item.CustomerName || "NA",
                "SLA CATEGORIES": item.SLACategoryName || "NA",
                "DESCRIPTION": item.Remarks || "NA",
                "VALUE TYPE": item.ValueType || "NA",
                "BASELINE": item.BaseLine || "NA",
                "TARGET": item.TargetPercentage || "NA",
                "TARGET VALUE": item.TargetValue || "NA",
                "START DATE": item.StartDate ? moment(item.StartDate).format('DD/MM/YYYY') : "NA",
                "END DATE": item.EndDate ? moment(item.EndDate).format('DD/MM/YYYY') : "NA",
                "ASSIGNED TO": item.AssignedTo || "NA",
                "DEPARTMENT": item.DepartmentName || "NA",
                "ASSIGNED SCORE": item.AssignedScore || "NA",
                "STATUS": item.Status || "NA",
            }));

        if (!dataToExport.length) {
            console.log("No data to export.");
            return;
        }

        const headers = Object.keys(dataToExport[0]);
        const csvRows = [headers.join(",")];
        dataToExport.forEach(row => {
            const values = headers.map(header => `"${String(row[header]).replace(/"/g, '""')}"`);
            csvRows.push(values.join(","));
        });

        const csvContent = "\uFEFF" + csvRows.join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const base64 = await blobToBase64(blob);

        const sessionData = JSON.parse(sessionStorage.getItem("SignInDetails")) || [];
        const signInType = sessionData[0]?.SignInType;
        const userID =
            signInType === "SuperAdmin"
                ? sessionData[0]?.SuperAdminID
                : signInType === "ClientAdmin"
                    ? sessionData[0]?.CompanyID
                    : signInType === "User"
                        ? sessionData[0]?.UserID
                        : null;

        if (!userID) {
            console.log("Invalid user ID from session.");
            return;
        }

        try {
            const response = await fetch(`${baseURL}/excomatixservices/api/Mail/PostAttachCSVDocument`, {
                method: "POST",
                headers: HeaderAuthentication.postExcomatixAuth,
                body: JSON.stringify({
                    UserID: userID,
                    FileName: "sla_data.csv",
                    File: base64.split(',')[1], // only the base64 part after comma
                }),
            });

            const resp = await response.json();

            if (resp.Success === 1 && resp.FilePath) {
                console.log("CSV uploaded successfully.");

                const subject = encodeURIComponent("CSV File: SLA Data");
                const body = encodeURIComponent(
                    `Hi,\n\nPlease find the link to download the CSV file below:\n\n${resp.FilePath}\n\nThanks!`
                );

                window.location.href = `mailto:?subject=${subject}&body=${body}`;
            } else {
                console.log("Upload failed. " + (resp.Msg || "Unknown error."));
            }
        } catch (err) {
            console.error("Upload Error:", err);
        }
    };

    const blobToBase64 = (blob) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showDashboardLibraryButton={false}
                        showSaveCustomViewButton={false}
                        showAnalyticsButton={true}
                        showDownloadDropdown={true}
                        onClick={handleAnalyticsClick}
                        onExcelDownloadClick={handleDownloadExcel}
                        onPdfDownloadClick={handleDownloadPDF}
                        onWordDownloadClick={handleDownloadWord}
                        onPrintClick={handlePrint}
                        onImageClick={handleDownloadImage}
                        onEmailCsvClick={handleEmailWithCsvDownload}
                        customViews={customViews}
                    />
                </div>
                {/* <div className="customermanagement-content"> */}
                <Row className='m-0 work-queue-tabs'>
                    <Col className='p-0'>
                        <Tab.Container activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
                            <Nav variant="tabs">
                                <Nav.Item>
                                    <Nav.Link eventKey="assignTo">
                                        SLA
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="updateValue">
                                        Assigned SLA
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <div className="customer-management-container">
                                <div className='customermanagement-content-container pt-0'>
                                    <Tab.Content className="customermanagement-content">
                                        <Tab.Pane eventKey="assignTo">
                                            <AssignToTable assignedToSlaData={assignedToSlaData} loading={loading} assignedToSlaDatas={assignedToSlaDatas} searchText={searchText} setSearchText={setSearchText} setSearchQuery={setSearchQuery} setSearchParams={setSearchParams} />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="updateValue">
                                            <UpdatedValueTable assignedToSlaData={assignedToSlaData} loading={updateSlaLoading} setLoading={setUpdateSlaLoading} assignedToSlaDatas={assignedToSlaDatas} updatedSlaDatas={updatedSlaDatas} updtedSearchText={updtedSearchText} setUpdatedSearchText={setUpdatedSearchText} setUpdatedSearchParams={setUpdatedSearchParams} setUpdatedSearchQuery={setUpdatedSearchQuery} />
                                        </Tab.Pane>
                                    </Tab.Content>
                                </div>
                            </div>
                        </Tab.Container>
                    </Col>
                </Row>

                {/* </div> */}
            </Main>
        </div>
    );
};

export default SLA;
